import Component from "@glimmer/component";
import { guidFor } from "@ember/object/internals";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

const SegmentedButtonsOption = <template>
  <label
    class="flex items-center justify-center cursor-pointer text-sm bg-gray-50 text-gray-500"
    data-test-segmented-button={{@option.value}}
  >
    <input
      class="sr-only peer"
      type="radio"
      name={{@name}}
      value={{@option.value}}
      disabled={{@option.disabled}}
      checked={{@option.checked}}
    />
    <span
      class="px-4 py-2 rounded hover:bg-gray-100 hover:border-gray-300 peer-checked:border peer-checked:bg-white peer-checked:text-black peer-checked:hover:bg-white peer-disabled:cursor-not-allowed peer-disabled:text-gray-200 peer-focus-visible:ring-1 peer-focus-visible:ring-blue-700"
    >
      {{@option.label}}
    </span>
  </label>
</template>;

@forbidExtraArgs
export default class SegmentedButtons extends Component {
  @arg options;
  @arg label;
  @arg name = `segmented-buttons-${guidFor(this)}`;

  <template>
    <fieldset class="mt-4">
      {{#if this.label}}
        <legend class="w-full mb-2 block text-sm font-normal text-gray-700">
          {{this.label}}
        </legend>
      {{/if}}

      <div
        class="flex gap-2 w-full bg-gray-50 border border-gray-200 rounded p-1"
        role="radiogroup"
        ...attributes
        {{mergeClasses}}
      >
        {{#each this.options as |option|}}
          <SegmentedButtonsOption @option={{option}} @name={{this.name}} />
        {{/each}}
      </div>
    </fieldset>
  </template>
}
